<template>
  <div class="top-box">
    <div class="header-container">
      <el-row :gutter="0">
        <el-col :span="13">
          <div class="header-time">
            <span>欢迎访问中共神木市委党校(神木市行政学校)</span>
            <span>{{ nowCal.cYear+'/'+nowCal.cMonth+'/'+nowCal.cDay }}</span>
            <span>{{ nowCal.ncWeek }}</span>
            <span>(农历{{ nowCal.gzYear}}年{{ nowCal.IMonthCn }}{{ nowCal.IDayCn }})</span>
          </div>
          <!--        <div class="grid-content bg-purple">
                    <el-image style="width: 25rem; height: 5rem; margin: 1.5rem 0;" :src="logo" :fit="fit"></el-image>
                  </div>-->
        </el-col>
        <el-col :span="5">
          <span @click="setHome()">网站设为首页</span> |
          <span @click="savePage()">加入收藏</span>
        </el-col>
        <el-col :span="6">
          <div class="search">
            <el-input v-model="searchKeywords" :placeholder="hotSearchKeywords" class="input-with-select">
              <template #append>
                <el-button :icon="Search" @click="search()"></el-button>
              </template>
            </el-input>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { watch } from "vue";
import { Search } from '@element-plus/icons-vue'
import {mapState} from "vuex"

export default {
  name: "Header",
  watch:{
    'config'() {
      this.hotSearchKeywords = this.config.hot_search_keywords
    }
  },
  data(){
    watch(this.config, (newVal, oldVal) => {
      console.log(newVal, oldVal)
      this.hotSearchKeywords = this.config.hot_search_keywords;
    })
    return {
      searchKeywords:'',
      hotSearchKeywords:'',
      Search: Search,
    }
  },
  computed: {
    ...mapState(['config'])
  },
  created() {
    this.hotSearchKeywords = this.config===undefined?'请输入要搜索的关键词':this.config.hot_search_keywords;
    const d = new Date();
    this.nowCal = this.$calendar.calendar.solar2lunar(d.getFullYear(),d.getMonth() + 1,d.getDate())
    setInterval(this.getCurrentTime,1000);
  },
  methods:{
    getCurrentTime(){
      const d = new Date()
      let h = d.getHours(), m = d.getMinutes()
      this.nowTime = (h>9?h:'0'+h) + ':' + (m>9?m:'0'+m)
    },
    search() {
      let paramsList = {
        keyword: this.searchKeywords
      }
      this.$router.push({
        path: '/search/'+Math.random(),
        query: {
          keyword: paramsList.keyword,
        }
      })
    },

    // 加入收藏
    savePage() {
      let title = "中共神木市委党校(神木市行政学校)"
      let url = encodeURI(window.location.host);
      try {
        window.external.addFavorite(url, title);
      } catch (e) {
        try {
          window.sidebar.addPanel(url, title, "");
        } catch (e) {
          alert("加入收藏失败，请使用Ctrl+D进行添加,或手动在浏览器里进行设置.");
        }
      }
    },

    // 设为首页
    setHome() {
      let url = window.location.host
      alert("您的浏览器不支持，请按照下面步骤操作：1.打开浏览器设置。2.点击设置网页。3.输入："+url+"点击确定。");
    }
  }
}
</script>

<style scoped>
.top-box {
  width: 100%;
  background: #BC0000;
}
/deep/ .el-icon svg {
  width: 20px;
  height: 20px;
}
/deep/ .el-col {
  height: 2.6rem;
}
  .header-container{
    color: #fff;
    width: 1200px;
    height: 2.6rem;
    line-height: 2.6rem;
    background: #BC0000;
    margin: 0 auto;
  }
  /deep/ .el-input input {
    --el-input-focus-border: #fff;
    --el-input-focus-border-size: 2px;
    background: #BC0000;
    border-radius: 1.5rem;
    height: 1.5rem;
  }
  /deep/ .el-input .el-input-group__append {
    background: none;
    border: none;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    padding: 0 20px 0 10px;
  }
  .header-time{
    font-size: 0.9rem;
    letter-spacing: 2px;
    overflow: hidden;
    height: 8rem;
  }
  span{
    margin: 0 .3rem;
    font-size: 14px;
  }
  /deep/ .el-input__inner{
    color:#fff;
  }

</style>